import { CustomAttribute, CustomAttributeOption } from './directory.model';

export interface AccountsSpotlightDirectory {
  spotlight_directory_id: number;
  id: number;
  visible: true;
  url: string;
  completion: AccountsSpotlightCompletion;
  spotlight_directory: AccountsSpotlightDirectoryInfo;
  custom_attributes: CustomAttribute[];
}

export interface AccountsSpotlightCompletion {
  percent: number;
  // this object will be returned if there is a non-completed step
  next_step: {
    translation_key: string;
    custom_attribute_label: string; // will be returned only if the next step is a custom attribute
  };
}

export interface AccountsSpotlightDirectoryInfo {
  name: string;
  domain: string;
  visible: boolean;
  published: boolean;
}

export interface AccountsSpotlightDirectoryUserSettings {
  visible?: boolean;
  custom_attribute_values?: Partial<CustomAttributeOption>[];
}
